<mat-card appearance="outlined" class="tw:mb-4">
  <mat-card-content>
    <div class="tw:flex tw:items-center tw:gap-6 tw:flex-wrap">

      <div class="tw:border tw:border-[#ccc] tw:rounded tw:overflow-hidden tw:flex-shrink-0">
        <div class="tw:grid tw:grid-cols-3 tw:border-b tw:border-b-[#eee]">
          <span class="tw:px-2.5 tw:py-1.5 tw:text-[11px] tw:text-[#555] tw:border-r tw:border-r-[#eee]">Date</span>
          <span class="tw:px-2.5 tw:py-1.5 tw:text-[11px] tw:text-[#555] tw:border-r tw:border-r-[#eee]">Start</span>
          <span class="tw:px-2.5 tw:py-1.5 tw:text-[11px] tw:text-[#555]">Finish</span>
        </div>
        <div class="tw:grid tw:grid-cols-3 tw:items-center">
          <span class="tw:px-2.5 tw:py-2 tw:text-[13px] tw:border-r tw:border-r-[#eee]">{{ session.date | date: 'dd/MM/yyyy'}}</span>
          <span class="tw:px-2.5 tw:py-2 tw:text-[13px] tw:border-r tw:border-r-[#eee]">{{ session.startTime }}</span>
          <span class="tw:px-2.5 tw:py-2 tw:text-[13px]">{{ session.endTime }}</span>
        </div>
      </div>

      <div class="tw:flex tw:flex-col tw:gap-[3px]">
        <span class="tw:text-[11px] tw:text-[#888]">Subject</span>
        <span class="tw:text-[13px] tw:text-[#333]">{{ session.subject }}</span>
      </div>

      <div class="tw:flex tw:flex-col tw:gap-[3px]">
        <span class="tw:text-[11px] tw:text-[#888]">Session type</span>
        <span class="tw:text-[13px] tw:text-[#333]">{{ session.sessionType }}</span>
      </div>

      <div class="tw:flex tw:flex-col tw:gap-[3px]">
        <span class="tw:text-[11px] tw:text-[#888]">Delivery mode</span>
        <span class="tw:text-[13px] tw:text-[#333]">{{ session.deliveryMode }}</span>
      </div>

    </div>

    @if (tutorCancelled && tutorCancelledSummary) {
      <div class="tw:mt-3 tw:px-3 tw:py-2.5 tw:bg-[#fff5f5] tw:border tw:border-[#f5c0c0] tw:rounded-[3px] tw:text-xs tw:text-[#333] tw:leading-[1.7]">
        <strong class="tw:text-[#c00]">Tutor cancelled</strong> — {{ tutorCancelledSummary.reason }}<br>
        <span class="tw:text-[#666]">{{ tutorCancelledSummary.comments }}</span>
      </div>
    }
  </mat-card-content>
</mat-card>
